import React from 'react';

export const WellsaidLabsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="245" height="36" viewBox="0 0 245 36">
    <defs>
      <path id="a" d="M.207216.000216h16.40592V36H.207216z" />
      <path id="c" d="M0 36h154.13976V0H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#38EF7D"
        d="M72.000072 18.000072V3.088152c-3.97656-4.11768-10.42344-4.11768-14.4 0l-7.2 7.45632-7.2-7.45632c-3.97656-4.11768-10.42344-4.11768-14.4 0l-7.2 7.45632-7.2-7.45632c-3.97656-4.11768-10.42344-4.11768-14.4 0v14.91192c3.67776 3.80808 3.67776 3.80808 0 0l14.4 14.91192c3.97656 4.11768 10.42344 4.11768 14.4 0l7.2-7.45632 7.2 7.45632c3.97656 4.11768 10.42344 4.11768 14.4 0l14.4-14.91192c-3.2976 3.41496-3.2976 3.41424 0 0"
      />
      <path
        fill="#000"
        fillOpacity=".2"
        d="M57.554424 17.959032c-3.90888-4.09824-10.42056-4.02624-14.35464.04752l-7.2 7.4556 7.2 7.4556c3.96 4.10112 10.44 4.10112 14.4 0l14.4-14.9112c-3.99168 4.13352-10.4724 4.11768-14.44536-.04752"
      />
      <path
        fill="#000"
        fillOpacity=".1"
        d="m28.800144 3.09456-14.4 14.91192c-3.97656 4.11768-10.42344 4.11768-14.4 0l14.4 14.9112c3.96 4.10112 10.44 4.10112 14.4 0l14.4-14.9112c3.97656-4.11768 10.42344-4.11768 14.4 0l-7.2-7.45632-7.2-7.4556c-3.96-4.1004-10.44-4.1004-14.4 0"
      />
      <path
        fill="#000"
        d="m112.595112.499968-3.06864 23.20056h-.10224l-3.01896-23.20056h-4.72968l-3.0204 23.20056h-.10008L95.485032.499968h-5.48496l5.43456 35.00064h5.43528l3.07008-20.8512h.10008l3.01968 20.8512h5.43528l5.43528-35.00064zm9.24048 0v35.00064h14.99688v-4.90032h-9.6624v-10.4004h7.80048v-4.90032h-7.80048v-9.89928h9.6624V.499968zm19.191168 0v35.00064h14.2416v-5.00112h-8.90712V.499968zm17.902944 0v35.00064h14.2416v-5.00112h-8.90712V.499968z"
      />
      <g transform="translate(90)">
        <g transform="translate(85.68)">
          <path
            fill="#000"
            d="M16.361136 8.000136v1.00008l-5.1336.49968v-1.10016c0-2.39976-.90576-3.49992-2.76696-3.49992-1.56096 0-2.6676.85032-2.6676 2.84976v.75024c0 1.95048 1.00728 3.55032 4.47912 6.70032 4.7304 4.35024 6.34104 7.2 6.34104 11.25v1.69992c0 5.15016-3.27168 7.85016-8.15256 7.85016-4.932 0-8.25336-2.84976-8.25336-8.00064v-2.29968l5.13288-.5004v2.40048c0 2.35008 1.10664 3.49992 3.01968 3.49992 1.60992 0 2.91816-.8496 2.91816-3.35016v-1.10016c0-2.1996-1.00584-3.79944-4.47768-6.94944-4.73184-4.35024-6.34176-7.2-6.34176-11.00088v-.84888c0-5.15016 3.01896-7.85016 7.95168-7.85016 4.93128 0 7.95096 2.84976 7.95096 7.99992"
          />
        </g>
        <path
          fill="#000"
          d="M111.766032 22.749984h4.47984l-2.16432-14.74992h-.1512l-2.16432 14.74992zm6.34104 12.74976-1.15776-7.94952h-5.88744l-1.15776 7.94952h-5.33376l6.08904-34.99992h6.7932l6.08904 34.99992h-5.43456z"
        />
        <path
          fill="#000"
          d="M127.39968 35.4996h5.33448V.49968h-5.33448zM142.967232 30.6h2.11392c2.56608 0 3.72456-1.35 3.72456-4.30056V9.69984c0-2.94984-1.15848-4.29984-3.72456-4.29984h-2.11392v25.2zm2.31552-30.10032c5.73768 0 8.85672 3.10032 8.85672 8.84952v17.30088c0 5.74992-3.11904 8.85024-8.85672 8.85024h-7.65V.49968h7.65z"
        />
      </g>
    </g>
  </svg>
);
